module.exports = __webpack_public_path__ + "media/images/investor-plug-and-play-b0963e5b.png";